module.exports = __webpack_public_path__ + "img/geocomposto3.e9fbe104.png";